// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/meet-the-flintstones.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const meetTheFlintstones: Score = {
  slug: "meet-the-flintstones",
  n: 9,
  title: "Meet the Flintstones",
  composer: "Hoyt Curtin",
  rights: "in-copyright",
  publicSafe: false,
  key: "C",
  fifths: 0,
  time: [4, 4],
  tempo: 120,
  staves: 1,
  clefs: ["treble"],
  bars: 19,
  barQuarters: 4.0,
  lowest: 60,
  highest: 74,
  hasLyrics: true,
  jasonNote: "You have to know this one! This melody is believed to have been inspired from part of the 'B' section of Beethoven's Piano Sonata No. 17 & reharmonized. Look out for the Staccato notes",
  teaches: ["staccato", "off-beat entries", "rests inside the phrase"],
  art: "/sight-reading/art/meet-the-flintstones.jpg",
  artRights: "studio",
  background: "/sight-reading/bg/meet-the-flintstones.jpg",
  notes: [
    {
  bar: 1,
  hand: "rh",
  start: 0.0,
  dur: 1.0,
  midi: 67,
  pitch: "G4",
  d: "quarter",
  lyric: "Flint"
},
    {
  bar: 1,
  hand: "rh",
  start: 1.0,
  dur: 1.0,
  midi: 60,
  pitch: "C4",
  d: "quarter",
  art: ["staccato"],
  lyric: "stones"
},
    { bar: 1, hand: "rh", start: 2.0, dur: 0.5, rest: true, d: "eighth" },
    {
  bar: 1,
  hand: "rh",
  start: 2.5,
  dur: 0.5,
  midi: 72,
  pitch: "C5",
  d: "eighth",
  tie: "start",
  lyric: "meet"
},
    { bar: 1, hand: "rh", start: 3.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth", tie: "stop" },
    { bar: 1, hand: "rh", start: 3.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth", lyric: "the" },
    {
  bar: 2,
  hand: "rh",
  start: 4.0,
  dur: 1.0,
  midi: 67,
  pitch: "G4",
  d: "quarter",
  lyric: "flint"
},
    {
  bar: 2,
  hand: "rh",
  start: 5.0,
  dur: 1.0,
  midi: 60,
  pitch: "C4",
  d: "quarter",
  art: ["staccato"],
  lyric: "stones"
},
    { bar: 2, hand: "rh", start: 6.0, dur: 0.5, rest: true, d: "eighth" },
    {
  bar: 2,
  hand: "rh",
  start: 6.5,
  dur: 0.5,
  midi: 67,
  pitch: "G4",
  d: "eighth",
  tie: "start",
  lyric: "they're"
},
    { bar: 2, hand: "rh", start: 7.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", tie: "stop" },
    { bar: 2, hand: "rh", start: 7.5, dur: 0.5, midi: 65, pitch: "F4", d: "eighth", lyric: "the" },
    { bar: 3, hand: "rh", start: 8.0, dur: 0.5, midi: 64, pitch: "E4", d: "eighth", lyric: "mo" },
    { bar: 3, hand: "rh", start: 8.5, dur: 0.5, midi: 64, pitch: "E4", d: "eighth", lyric: "dern" },
    { bar: 3, hand: "rh", start: 9.0, dur: 0.5, midi: 65, pitch: "F4", d: "eighth", lyric: "stone" },
    { bar: 3, hand: "rh", start: 9.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "age" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", lyric: "fa" },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", lyric: "mi" },
    { bar: 4, hand: "rh", start: 12.0, dur: 4.0, midi: 64, pitch: "E4", d: "whole", lyric: "ly" },
    {
  bar: 5,
  hand: "rh",
  start: 16.0,
  dur: 1.0,
  midi: 67,
  pitch: "G4",
  d: "quarter",
  lyric: "From"
},
    {
  bar: 5,
  hand: "rh",
  start: 17.0,
  dur: 1.0,
  midi: 60,
  pitch: "C4",
  d: "quarter",
  art: ["staccato"],
  lyric: "the"
},
    { bar: 5, hand: "rh", start: 18.0, dur: 0.5, rest: true, d: "eighth" },
    {
  bar: 5,
  hand: "rh",
  start: 18.5,
  dur: 0.5,
  midi: 72,
  pitch: "C5",
  d: "eighth",
  tie: "start",
  lyric: "town"
},
    { bar: 5, hand: "rh", start: 19.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth", tie: "stop" },
    { bar: 5, hand: "rh", start: 19.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth", lyric: "of" },
    { bar: 6, hand: "rh", start: 20.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "Bed" },
    {
  bar: 6,
  hand: "rh",
  start: 21.0,
  dur: 1.0,
  midi: 60,
  pitch: "C4",
  d: "quarter",
  art: ["staccato"],
  lyric: "rock"
},
    { bar: 6, hand: "rh", start: 22.0, dur: 0.5, rest: true, d: "eighth" },
    {
  bar: 6,
  hand: "rh",
  start: 22.5,
  dur: 0.5,
  midi: 67,
  pitch: "G4",
  d: "eighth",
  tie: "start",
  lyric: "they're"
},
    { bar: 6, hand: "rh", start: 23.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", tie: "stop" },
    { bar: 6, hand: "rh", start: 23.5, dur: 0.5, midi: 65, pitch: "F4", d: "eighth", lyric: "a" },
    { bar: 7, hand: "rh", start: 24.0, dur: 0.5, midi: 64, pitch: "E4", d: "eighth", lyric: "page" },
    {
  bar: 7,
  hand: "rh",
  start: 24.5,
  dur: 0.5,
  midi: 64,
  pitch: "E4",
  d: "eighth",
  lyric: "right"
},
    { bar: 7, hand: "rh", start: 25.0, dur: 0.5, midi: 65, pitch: "F4", d: "eighth", lyric: "out" },
    { bar: 7, hand: "rh", start: 25.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "of" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", lyric: "his" },
    { bar: 7, hand: "rh", start: 27.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", lyric: "to" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 60, pitch: "C4", d: "whole", lyric: "ry" },
    {
  bar: 9,
  hand: "rh",
  start: 32.0,
  dur: 1.0,
  midi: 71,
  pitch: "B4",
  d: "quarter",
  lyric: "Let's"
},
    {
  bar: 9,
  hand: "rh",
  start: 33.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  art: ["staccato"],
  lyric: "ride"
},
    { bar: 9, hand: "rh", start: 34.0, dur: 0.5, rest: true, d: "eighth" },
    {
  bar: 9,
  hand: "rh",
  start: 34.5,
  dur: 0.5,
  midi: 72,
  pitch: "C5",
  d: "eighth",
  tie: "start",
  lyric: "with"
},
    { bar: 9, hand: "rh", start: 35.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth", tie: "stop" },
    { bar: 9, hand: "rh", start: 35.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth", lyric: "the" },
    { bar: 10, hand: "rh", start: 36.0, dur: 0.5, midi: 71, pitch: "B4", d: "eighth", lyric: "fa" },
    {
  bar: 10,
  hand: "rh",
  start: 36.5,
  dur: 0.5,
  midi: 69,
  pitch: "A4",
  d: "eighth",
  lyric: "mily"
},
    {
  bar: 10,
  hand: "rh",
  start: 37.0,
  dur: 0.5,
  midi: 69,
  pitch: "A4",
  d: "eighth",
  lyric: "down"
},
    { bar: 10, hand: "rh", start: 37.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth", lyric: "the" },
    {
  bar: 10,
  hand: "rh",
  start: 38.0,
  dur: 1.0,
  midi: 69,
  pitch: "A4",
  d: "quarter",
  lyric: "street"
},
    { bar: 10, hand: "rh", start: 39.0, dur: 1.0, rest: true, d: "quarter" },
    {
  bar: 11,
  hand: "rh",
  start: 40.0,
  dur: 1.0,
  midi: 69,
  pitch: "A4",
  d: "quarter",
  lyric: "through"
},
    {
  bar: 11,
  hand: "rh",
  start: 41.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  art: ["staccato"],
  lyric: "the"
},
    { bar: 11, hand: "rh", start: 42.0, dur: 0.5, rest: true, d: "eighth" },
    {
  bar: 11,
  hand: "rh",
  start: 42.5,
  dur: 0.5,
  midi: 71,
  pitch: "B4",
  d: "eighth",
  tie: "start",
  lyric: "cour"
},
    { bar: 11, hand: "rh", start: 43.0, dur: 0.5, midi: 71, pitch: "B4", d: "eighth", tie: "stop" },
    { bar: 11, hand: "rh", start: 43.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth", lyric: "te" },
    { bar: 12, hand: "rh", start: 44.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth", lyric: "sy" },
    { bar: 12, hand: "rh", start: 44.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "of" },
    {
  bar: 12,
  hand: "rh",
  start: 45.0,
  dur: 0.5,
  midi: 67,
  pitch: "G4",
  d: "eighth",
  lyric: "Fred's"
},
    { bar: 12, hand: "rh", start: 45.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth", lyric: "two" },
    {
  bar: 12,
  hand: "rh",
  start: 46.0,
  dur: 1.0,
  midi: 67,
  pitch: "G4",
  d: "quarter",
  lyric: "feet"
},
    { bar: 12, hand: "rh", start: 47.0, dur: 1.0, rest: true, d: "quarter" },
    {
  bar: 13,
  hand: "rh",
  start: 48.0,
  dur: 1.0,
  midi: 67,
  pitch: "G4",
  d: "quarter",
  lyric: "when"
},
    {
  bar: 13,
  hand: "rh",
  start: 49.0,
  dur: 1.0,
  midi: 60,
  pitch: "C4",
  d: "quarter",
  art: ["staccato"],
  lyric: "you're"
},
    { bar: 13, hand: "rh", start: 50.0, dur: 0.5, rest: true, d: "eighth" },
    {
  bar: 13,
  hand: "rh",
  start: 50.5,
  dur: 0.5,
  midi: 72,
  pitch: "C5",
  d: "eighth",
  tie: "start",
  lyric: "with"
},
    { bar: 13, hand: "rh", start: 51.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth", tie: "stop" },
    { bar: 13, hand: "rh", start: 51.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth", lyric: "the" },
    {
  bar: 14,
  hand: "rh",
  start: 52.0,
  dur: 1.0,
  midi: 67,
  pitch: "G4",
  d: "quarter",
  lyric: "flint"
},
    {
  bar: 14,
  hand: "rh",
  start: 53.0,
  dur: 1.0,
  midi: 60,
  pitch: "C4",
  d: "quarter",
  art: ["staccato"],
  lyric: "stones"
},
    { bar: 14, hand: "rh", start: 54.0, dur: 0.5, rest: true, d: "eighth" },
    {
  bar: 14,
  hand: "rh",
  start: 54.5,
  dur: 0.5,
  midi: 67,
  pitch: "G4",
  d: "eighth",
  tie: "start",
  lyric: "have"
},
    { bar: 14, hand: "rh", start: 55.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", tie: "stop" },
    { bar: 14, hand: "rh", start: 55.5, dur: 0.5, midi: 65, pitch: "F4", d: "eighth", lyric: "a" },
    { bar: 15, hand: "rh", start: 56.0, dur: 0.5, midi: 64, pitch: "E4", d: "eighth", lyric: "yaa" },
    { bar: 15, hand: "rh", start: 56.5, dur: 0.5, midi: 64, pitch: "E4", d: "eighth", lyric: "baa" },
    { bar: 15, hand: "rh", start: 57.0, dur: 0.5, midi: 65, pitch: "F4", d: "eighth", lyric: "daa" },
    { bar: 15, hand: "rh", start: 57.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "baa" },
    {
  bar: 15,
  hand: "rh",
  start: 58.0,
  dur: 1.0,
  midi: 60,
  pitch: "C4",
  d: "quarter",
  lyric: "doo"
},
    {
  bar: 15,
  hand: "rh",
  start: 59.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  lyric: "time"
},
    { bar: 16, hand: "rh", start: 60.0, dur: 0.5, rest: true, d: "eighth" },
    { bar: 16, hand: "rh", start: 60.5, dur: 0.5, midi: 64, pitch: "E4", d: "eighth", lyric: "a" },
    { bar: 16, hand: "rh", start: 61.0, dur: 0.5, midi: 65, pitch: "F4", d: "eighth", lyric: "daa" },
    { bar: 16, hand: "rh", start: 61.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "baa" },
    {
  bar: 16,
  hand: "rh",
  start: 62.0,
  dur: 1.0,
  midi: 60,
  pitch: "C4",
  d: "quarter",
  lyric: "doo"
},
    {
  bar: 16,
  hand: "rh",
  start: 63.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  lyric: "time"
},
    { bar: 17, hand: "rh", start: 64.0, dur: 0.5, rest: true, d: "eighth" },
    {
  bar: 17,
  hand: "rh",
  start: 64.5,
  dur: 0.5,
  midi: 64,
  pitch: "E4",
  d: "eighth",
  lyric: "we'll"
},
    {
  bar: 17,
  hand: "rh",
  start: 65.0,
  dur: 0.5,
  midi: 65,
  pitch: "F4",
  d: "eighth",
  lyric: "have"
},
    { bar: 17, hand: "rh", start: 65.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "a" },
    {
  bar: 17,
  hand: "rh",
  start: 66.0,
  dur: 1.0,
  midi: 72,
  pitch: "C5",
  d: "quarter",
  lyric: "gay"
},
    {
  bar: 17,
  hand: "rh",
  start: 67.0,
  dur: 1.0,
  midi: 74,
  pitch: "D5",
  d: "quarter",
  lyric: "old"
},
    { bar: 18, hand: "rh", start: 68.0, dur: 4.0, midi: 72, pitch: "C5", d: "whole", lyric: "time" },
    { bar: 19, hand: "rh", start: 72.0, dur: 4.0, rest: true, d: "whole" },
  ],
};
